import { render, staticRenderFns } from "./SelfcheckBrowserBackModal.vue?vue&type=template&id=73aa973a&scoped=true&"
import script from "./SelfcheckBrowserBackModal.vue?vue&type=script&lang=js&"
export * from "./SelfcheckBrowserBackModal.vue?vue&type=script&lang=js&"
import style0 from "./SelfcheckBrowserBackModal.vue?vue&type=style&index=0&id=73aa973a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73aa973a",
  null
  
)

export default component.exports